var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"box"},_vm._l((_vm.url_list),function(item){return _c('div',{staticClass:"item"},[_c('div',[_c('a',{attrs:{"href":item.url,"target":"_blank","title":item.url}},[_vm._v(_vm._s(item.name))])])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }